import React, { useEffect, useRef } from "react";
import "./Plan.css";
// import { gsap } from "gsap";
import { Container, Col, Row, Button, Tab, Tabs, Table } from "react-bootstrap";
import HeroHow from "../../../Images/plan-image/calculator.png";

function Plan() {
  return (
    <>
      <section className="plan-section">
        <Container className="add-border">
          <Row>
                      <Col md={8} xs={12}>
              <div className="plan-alpha pr-5">
                <h2>
                  <span>Here's how</span>
                </h2>
                <Tabs
                  defaultActiveKey="home"
                  transition={true}
                  id="noanim-tab-example"
                >
                  <Tab eventKey="home" title="Plan A">
                    <Table responsive bordered>
                      <thead>
                        <tr>
                          <th>Script</th>
                          <th>&nbsp;</th>
                          <th>Lot Size</th>
                          <th>CMP</th>
                          <th>Total Value</th>
                          <th>Margin Required</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td rowSpan={2}>Nifty</td>
                          <td>Buy</td>
                          <td>50</td>
                          <td>17500</td>
                          <td>8,75,000</td>
                          <td>1,00,000</td>
                        </tr>
                        <tr>
                          <td>Sell</td>
                          <td>50</td>
                          <td>17600</td>
                          <td>8,80,000</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td colSpan={3}>Profit</td>
                          <td></td>
                          <td colSpan={2}>5,000</td>
                        </tr>
                        <tr>
                          <td colSpan={3}>Brokerage & Regulatory Charges	</td>
                          <td></td>
                          <td colSpan={2}>173</td>
                        </tr>
                        <tr>
                          <td>Net Profit</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>4827</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td colSpan={4} className="text-left pl-4">Interest earned on Ledger Balance</td>
                          <td colSpan={4}>100000*2.7% = 2700/12 = 225</td>
                        </tr>
                      </tbody>
                    </Table>
                    <Row>
                   
                      <Col xs={6} md={4} lg={4}>
                        <h3>&#8377;4,827</h3>
                        <p>
                          Net Profit <br />
                          (5000-173)
                        </p>
                      </Col>
                      <Col xs={6} md={4} lg={4}>
                        <h3>&#8377;225</h3>
                        <p>
                          Interest on Monthly basis <br />
                          (100000*2.7%)/12
                        </p>
                      </Col>
                      <Col
                        xs={{ span: 6, offset: 3 }}
                        md={{ span: 4, offset: 0 }}
                        lg={{ span: 4, offset: 0 }}
                      >
                        <h3>&#8377;5,052</h3>
                        <p>
                          Total Profit <br />
                          (4827 + 225)
                        </p>
                      </Col>
                      <div className="col-12 text-center"><small className="text-center"><i>Considering 2.7% as SBI Interest rate on Saving Bank Deposits </i></small></div>
                    </Row>
                  </Tab>
                  <Tab eventKey="profile" title="Plan B">
                    <Table responsive bordered>
                      <thead>
                        <tr>
                          <th>Script</th>
                          <th>&nbsp;</th>
                          <th>Lot Size</th>
                          <th>CMP</th>
                          <th>Total Value</th>
                          <th>Margin Required</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td rowSpan={2}>Nifty</td>
                          <td>Buy</td>
                          <td>50</td>
                          <td>17500</td>
                          <td>8,75,000</td>
                          <td>1,00,000</td>
                        </tr>
                        <tr>
                          <td>Sell</td>
                          <td>50</td>
                          <td>17600</td>
                          <td>8,80,000</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td colSpan={3}>Profit</td>
                          <td></td>
                          <td colSpan={2}>5,000</td>
                        </tr>
                        <tr>
                          <td colSpan={3}> Brokerage & Regulatory Charges</td>
                          <td></td>
                          <td colSpan={2}>163</td>
                        </tr>
                        <tr>
                          <td colSpan={4}>Total Profit</td>
                          <td>4837</td>
                          <td></td>
                        </tr>
                      </tbody>
                    </Table>
                  </Tab>
                </Tabs>
              </div>
            </Col>
            <Col md={4}>
              <img className="img-fluid plan-section-img" src={HeroHow} />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default Plan;
